import { FC } from 'react';
import { SvgIcon, SvgProps } from './SvgIcon';

interface SignalIconProps extends SvgProps {
  strength?: 0 | 1 | 2 | 3;
}

export const SignalIcon: FC<SignalIconProps> = ({ strength = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 29 29">
    <rect width="29" height="29" rx="14.5" fill="currentColor" />
    <g clipPath="url(#clip0_1163_47657)">
      {strength >= 1 && (
        <path
          d="M10.5 16L10.5 19"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {strength >= 2 && (
        <path
          d="M14.5 13L14.5 19"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {strength >= 3 && (
        <path
          d="M18.5 10L18.5 19"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </g>
    <defs>
      <clipPath id="clip0_1163_47657">
        <rect width="10" height="11" fill="white" transform="translate(9.5 9)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

SignalIcon.displayName = 'SignalIcon';
